import type { Language } from "element-plus/es/locale";
import en from "element-plus/es/locale/lang/en";
import id from "element-plus/es/locale/lang/id";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import type { Locale } from "@/i18n/text";

/** Element Plus 组件库语言包，与界面语言对齐 */
const ELEMENT_LOCALES: Record<Locale, Language> = {
  en,
  zh: zhCn,
  id,
};

/** 当前界面语言对应的 Element Plus locale */
export function elementPlusLocale(locale: Locale): Language {
  return ELEMENT_LOCALES[locale];
}
